import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postV2PatientWaitingRoomQueueDeviceCheck: build.mutation<
      PostV2PatientWaitingRoomQueueDeviceCheckApiResponse,
      PostV2PatientWaitingRoomQueueDeviceCheckApiArg
    >({
      query: () => ({
        url: `/v2/patient/waiting-room/queue/device-check`,
        method: "POST",
      }),
    }),
    postV2PatientWaitingRoomQueueReady: build.mutation<
      PostV2PatientWaitingRoomQueueReadyApiResponse,
      PostV2PatientWaitingRoomQueueReadyApiArg
    >({
      query: () => ({
        url: `/v2/patient/waiting-room/queue/ready`,
        method: "POST",
      }),
    }),
    getV2PatientWaitingRoomQueueStatus: build.query<
      GetV2PatientWaitingRoomQueueStatusApiResponse,
      GetV2PatientWaitingRoomQueueStatusApiArg
    >({
      query: () => ({ url: `/v2/patient/waiting-room/queue/status` }),
    }),
    getV2PatientWaitingRoomBySlug: build.query<
      GetV2PatientWaitingRoomBySlugApiResponse,
      GetV2PatientWaitingRoomBySlugApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/patient/waiting-room/${queryArg.slug}`,
      }),
    }),
    postV2PatientWaitingRoomBySlugCheckIn: build.mutation<
      PostV2PatientWaitingRoomBySlugCheckInApiResponse,
      PostV2PatientWaitingRoomBySlugCheckInApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/patient/waiting-room/${queryArg.slug}/check-in`,
        method: "POST",
        body: queryArg.waitingRoomCheckInRequest,
      }),
    }),
    putV2ProviderWaitingRoomAvailability: build.mutation<
      PutV2ProviderWaitingRoomAvailabilityApiResponse,
      PutV2ProviderWaitingRoomAvailabilityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/waiting-room/availability`,
        method: "PUT",
        body: queryArg.waitingRoomAvailabilityRequest,
      }),
    }),
    postV2ProviderWaitingRoomEncountersByEncounterIdJoin: build.mutation<
      PostV2ProviderWaitingRoomEncountersByEncounterIdJoinApiResponse,
      PostV2ProviderWaitingRoomEncountersByEncounterIdJoinApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/waiting-room/encounters/${queryArg.encounterId}/join`,
        method: "POST",
      }),
    }),
    postV2ProviderWaitingRoomHeartbeat: build.mutation<
      PostV2ProviderWaitingRoomHeartbeatApiResponse,
      PostV2ProviderWaitingRoomHeartbeatApiArg
    >({
      query: () => ({
        url: `/v2/provider/waiting-room/heartbeat`,
        method: "POST",
      }),
    }),
    getV2ProviderWaitingRoomLink: build.query<
      GetV2ProviderWaitingRoomLinkApiResponse,
      GetV2ProviderWaitingRoomLinkApiArg
    >({
      query: () => ({ url: `/v2/provider/waiting-room/link` }),
    }),
    getV2ProviderWaitingRoomQueue: build.query<
      GetV2ProviderWaitingRoomQueueApiResponse,
      GetV2ProviderWaitingRoomQueueApiArg
    >({
      query: () => ({ url: `/v2/provider/waiting-room/queue` }),
    }),
    deleteV2ProviderWaitingRoomQueueByEntryId: build.mutation<
      DeleteV2ProviderWaitingRoomQueueByEntryIdApiResponse,
      DeleteV2ProviderWaitingRoomQueueByEntryIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/waiting-room/queue/${queryArg.entryId}`,
        method: "DELETE",
        body: queryArg.waitingRoomRemoveRequest,
      }),
    }),
    postV2ProviderWaitingRoomQueueByEntryIdAdmit: build.mutation<
      PostV2ProviderWaitingRoomQueueByEntryIdAdmitApiResponse,
      PostV2ProviderWaitingRoomQueueByEntryIdAdmitApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/waiting-room/queue/${queryArg.entryId}/admit`,
        method: "POST",
        body: queryArg.waitingRoomAdmitRequest,
      }),
    }),
    postV2ProviderWaitingRoomQueueByEntryIdAdmitAdditional: build.mutation<
      PostV2ProviderWaitingRoomQueueByEntryIdAdmitAdditionalApiResponse,
      PostV2ProviderWaitingRoomQueueByEntryIdAdmitAdditionalApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/waiting-room/queue/${queryArg.entryId}/admit-additional`,
        method: "POST",
        body: queryArg.waitingRoomAdmitAdditionalRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type PostV2PatientWaitingRoomQueueDeviceCheckApiResponse =
  /** status 200 OK */ WaitingRoomDeviceCheckResponse;
export type PostV2PatientWaitingRoomQueueDeviceCheckApiArg = void;
export type PostV2PatientWaitingRoomQueueReadyApiResponse =
  /** status 200 OK */ WaitingRoomReadyResponse;
export type PostV2PatientWaitingRoomQueueReadyApiArg = void;
export type GetV2PatientWaitingRoomQueueStatusApiResponse =
  /** status 200 OK */ WaitingRoomQueueStatusResponse;
export type GetV2PatientWaitingRoomQueueStatusApiArg = void;
export type GetV2PatientWaitingRoomBySlugApiResponse =
  /** status 200 OK */ WaitingRoomResolveResponse;
export type GetV2PatientWaitingRoomBySlugApiArg = {
  slug: string;
};
export type PostV2PatientWaitingRoomBySlugCheckInApiResponse =
  /** status 200 OK */ WaitingRoomCheckInResponse;
export type PostV2PatientWaitingRoomBySlugCheckInApiArg = {
  slug: string;
  waitingRoomCheckInRequest: WaitingRoomCheckInRequest;
};
export type PutV2ProviderWaitingRoomAvailabilityApiResponse =
  /** status 200 OK */ WaitingRoomAvailabilityResponse;
export type PutV2ProviderWaitingRoomAvailabilityApiArg = {
  waitingRoomAvailabilityRequest: WaitingRoomAvailabilityRequest;
};
export type PostV2ProviderWaitingRoomEncountersByEncounterIdJoinApiResponse =
  /** status 200 OK */ WaitingRoomProviderJoinResponse;
export type PostV2ProviderWaitingRoomEncountersByEncounterIdJoinApiArg = {
  encounterId: string;
};
export type PostV2ProviderWaitingRoomHeartbeatApiResponse =
  /** status 200 OK */ WaitingRoomAvailabilityResponse;
export type PostV2ProviderWaitingRoomHeartbeatApiArg = void;
export type GetV2ProviderWaitingRoomLinkApiResponse =
  /** status 200 OK */ WaitingRoomLinkResponse;
export type GetV2ProviderWaitingRoomLinkApiArg = void;
export type GetV2ProviderWaitingRoomQueueApiResponse =
  /** status 200 OK */ WaitingRoomQueueListResponse;
export type GetV2ProviderWaitingRoomQueueApiArg = void;
export type DeleteV2ProviderWaitingRoomQueueByEntryIdApiResponse =
  /** status 200 OK */ WaitingRoomRemoveResponse;
export type DeleteV2ProviderWaitingRoomQueueByEntryIdApiArg = {
  entryId: string;
  waitingRoomRemoveRequest: WaitingRoomRemoveRequest;
};
export type PostV2ProviderWaitingRoomQueueByEntryIdAdmitApiResponse =
  /** status 200 OK */ WaitingRoomAdmitResponse;
export type PostV2ProviderWaitingRoomQueueByEntryIdAdmitApiArg = {
  entryId: string;
  waitingRoomAdmitRequest: WaitingRoomAdmitRequest;
};
export type PostV2ProviderWaitingRoomQueueByEntryIdAdmitAdditionalApiResponse =
  /** status 200 OK */ WaitingRoomAdmitAdditionalResponse;
export type PostV2ProviderWaitingRoomQueueByEntryIdAdmitAdditionalApiArg = {
  entryId: string;
  waitingRoomAdmitAdditionalRequest: WaitingRoomAdmitAdditionalRequest;
};
export type WaitingRoomDeviceCheckResponse = {
  /** State after the transition. Always 'DEVICE_CHECK'. */
  current_state: "DEVICE_CHECK";
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type WaitingRoomReadyResponse = {
  /** State after the transition. Always 'IN_QUEUE'. */
  current_state: "IN_QUEUE";
  /** 1-indexed position in the provider's IN_QUEUE sorted set after the transition. ``None`` when the entry is not yet a member of the sorted set (Redis race window only). */
  position?: number | null;
  /** Total number of IN_QUEUE members after the transition. */
  queue_length: number;
};
export type WaitingRoomAdmission = {
  /** ISO-8601 UTC expiration of the meeting token. The patient should rejoin via /queue/status before this time. */
  expires_at: string;
  /** Freshly-minted Daily meeting token scoped to this queue entry. Owner tokens are never returned to patients. */
  patient_token: string;
  /** Daily room name. */
  room_name: string;
  /** Daily room URL. */
  room_url: string;
};
export type WaitingRoomQueueStatusResponse = {
  /** Daily room credentials. Populated only when ``current_state`` is ADMITTED or IN_CALL — the patient has been let into a call and needs the room URL + token to (re)join. Null in every other state. */
  admission?: WaitingRoomAdmission | null;
  /** Current queue state. One of CHECKED_IN, DEVICE_CHECK, IN_QUEUE, ADMITTED, IN_CALL, COMPLETED, REMOVED, ABANDONED. Terminal states (COMPLETED/REMOVED/ABANDONED) signal the client to stop polling this endpoint. */
  current_state: string;
  /** 1-indexed position in the provider's queue. ``None`` when not currently a member of the sorted set. */
  position?: number | null;
  /** Whether the provider is currently online. */
  provider_status: "online" | "offline";
  /** Total number of IN_QUEUE members. */
  queue_length: number;
  /** Queue entry ID this token is bound to. */
  waiting_room_queue_entry_id: string;
};
export type WaitingRoomResolveResponse = {
  /** Whether the provider is currently accepting new patients into the waiting room. True iff the provider has an unexpired Redis availability key (set by PUT /v2/provider/waiting-room/availability and refreshed by POST /v2/provider/waiting-room/heartbeat). */
  is_accepting: boolean;
  /** Provider's display name for the waiting room landing page. Sourced from provider_billing_info.communications_name with a first/last-name fallback. */
  provider_display_name: string;
  /** Provider's specialization, if any. */
  specialty?: string | null;
};
export type WaitingRoomCheckInResponse = {
  /** ISO-8601 UTC timestamp. Matches the JWT ``exp`` claim; the client should reconnect or re-check-in before this time. */
  expires_at: string;
  /** 1-indexed position within the provider's IN_QUEUE sorted set at the moment of check-in. ``None`` when the patient has not yet transitioned to IN_QUEUE (patients start in CHECKED_IN). */
  position?: number | null;
  /** Total number of IN_QUEUE members at the moment of check-in. */
  queue_length: number;
  /** Path of the patient SSE subscribe endpoint. The client passes the token back via Authorization header or ?token= query arg. */
  subscribe_url: string;
  /** Waiting-room JWT. Use as ``Authorization: Bearer`` (or ``?token=`` fallback) against the SSE subscribe and queue status endpoints. */
  token: string;
  /** Stable ID of the newly-created queue entry. */
  waiting_room_queue_entry_id: string;
};
export type WaitingRoomCheckInRequest = {
  /** Optional patient-provided DOB as YYYY-MM-DD. Captured only when the provider asks for it. */
  patient_dob?: string | null;
  /** Patient-provided name. Encrypted into the queue entry PHI blob. */
  patient_name: string;
  /** Optional patient-provided reason for visit. */
  reason_for_visit?: string | null;
};
export type WaitingRoomAvailabilityResponse = {
  /** Current provider availability after the call. */
  status: "online" | "offline";
};
export type WaitingRoomAvailabilityRequest = {
  /** Target availability. 'online' publishes a Redis availability key with a ~75s TTL that the heartbeat endpoint refreshes; 'offline' deletes it. A provider who stops heartbeating for 60-90s drops to offline automatically. */
  status: "online" | "offline";
};
export type WaitingRoomProviderJoinResponse = {
  /** Encounter the call belongs to. */
  encounter_id: string;
  /** ISO-8601 UTC expiration of the owner token. The provider should rejoin via this endpoint before this time. */
  expires_at: string;
  /** Freshly-minted Daily owner token for the provider. */
  owner_token: string;
  /** Daily room name. */
  room_name: string;
  /** Daily room URL. */
  room_url: string;
};
export type WaitingRoomLinkResponse = {
  /** Provider's display name for the waiting room landing page. Sourced from provider_billing_info.communications_name with a first/last-name fallback. */
  display_name: string;
  /** Short patient-facing URL of the form {INTAKE_FORMS_BASE_URL}/w/{slug}. */
  short_url: string;
  /** Provider's specialization, if any. */
  specialty?: string | null;
};
export type WaitingRoomQueueEntryResponse = {
  /** ISO-8601 timestamp of initial check-in. */
  checked_in_at?: string | null;
  /** Current queue state. One of CHECKED_IN, DEVICE_CHECK, IN_QUEUE, ADMITTED, IN_CALL. */
  current_state: string;
  /** Patient-provided DOB (YYYY-MM-DD) if collected. */
  patient_dob?: string | null;
  /** Patient-provided name (decrypted from the queue entry PHI blob). */
  patient_name: string;
  /** Patient-provided reason for visit if collected. */
  reason_for_visit?: string | null;
  /** Seconds elapsed since ``checked_in_at``. Computed server-side so every client displays the same wait time. */
  wait_seconds?: number | null;
  /** Stable ID for this queue entry. */
  waiting_room_queue_entry_id: string;
};
export type WaitingRoomQueueListResponse = {
  /** Non-terminal queue entries in FIFO order. */
  entries?: WaitingRoomQueueEntryResponse[];
  /** Whether the provider is currently online. */
  provider_status: "online" | "offline";
};
export type WaitingRoomRemoveResponse = {
  /** Always 'REMOVED'. */
  current_state: "REMOVED";
  /** Reason persisted on the row. */
  removed_reason: "misdirected" | "no_show" | "inappropriate" | "other";
  /** Removed entry. */
  waiting_room_queue_entry_id: string;
};
export type WaitingRoomRemoveRequest = {
  /** Why the entry is being removed. Carried on the audit event and persisted to ``waiting_room_queue_entries.removed_reason``. */
  reason: "misdirected" | "no_show" | "inappropriate" | "other";
  /** Optional free-text note. Truncated at 500 characters. Not carried on ProductEvents to keep analytics cardinality predictable. */
  reason_detail?: string | null;
};
export type WaitingRoomAdmittedParticipant = {
  /** Daily meeting token for this participant to join. */
  patient_token: string;
  /** Queue entry ID that was admitted. */
  waiting_room_queue_entry_id: string;
};
export type WaitingRoomAdmitResponse = {
  /** Additional queue entries transitioned to ADMITTED into the same room. Each carries its own patient_token. */
  additional_patients_admitted?: WaitingRoomAdmittedParticipant[];
  /** Encounter ID created for this admission. */
  encounter_id: string;
  /** ISO-8601 expiration time of the owner token. Patient tokens share the same expiration. */
  expires_at: string;
  /** Queue entry IDs that could not be admitted as additional participants (invalid state, wrong owner, or token-mint failure). The primary admission succeeded regardless; these must be re-admitted individually. */
  failed_additional_entry_ids?: string[];
  /** Daily owner token for the admitting provider. */
  owner_token: string;
  /** Daily room name. */
  room_name: string;
  /** Daily room URL. */
  room_url: string;
  /** Primary queue entry admitted. */
  waiting_room_queue_entry_id: string;
};
export type WaitingRoomAdmitRequest = {
  /** Optional list of additional queue entry IDs to admit into the same Daily room (one-click group admit). Each must be owned by the caller and in IN_QUEUE or DEVICE_CHECK. Failure modes split two ways: a pre-flight validation failure on any additional entry (wrong owner, wrong state, not found) 4xx's the whole request and the primary is not admitted. Only Daily token-mint failures (transient Daily 5xx etc.) are reported per-entry in ``failed_additional_entry_ids`` with the primary admission still succeeding. */
  additional_participant_entry_ids?: string[];
};
export type WaitingRoomAdmitAdditionalResponse = {
  /** Shared encounter ID (same as the primary patient's). */
  encounter_id: string;
  /** ISO-8601 expiration time of the token. */
  expires_at: string;
  /** Daily meeting token for this participant. */
  patient_token: string;
  /** Daily room name. */
  room_name: string;
  /** Daily room URL. */
  room_url: string;
  /** Queue entry admitted as additional participant. */
  waiting_room_queue_entry_id: string;
};
export type WaitingRoomAdmitAdditionalRequest = {
  /** Queue entry ID of the primary (already-admitted) patient whose Daily room this entry should join. The primary entry must be in ADMITTED or IN_CALL state and own the encounter. */
  primary_queue_entry_id: string;
};
export const {
  usePostV2PatientWaitingRoomQueueDeviceCheckMutation,
  usePostV2PatientWaitingRoomQueueReadyMutation,
  useGetV2PatientWaitingRoomQueueStatusQuery,
  useGetV2PatientWaitingRoomBySlugQuery,
  usePostV2PatientWaitingRoomBySlugCheckInMutation,
  usePutV2ProviderWaitingRoomAvailabilityMutation,
  usePostV2ProviderWaitingRoomEncountersByEncounterIdJoinMutation,
  usePostV2ProviderWaitingRoomHeartbeatMutation,
  useGetV2ProviderWaitingRoomLinkQuery,
  useGetV2ProviderWaitingRoomQueueQuery,
  useDeleteV2ProviderWaitingRoomQueueByEntryIdMutation,
  usePostV2ProviderWaitingRoomQueueByEntryIdAdmitMutation,
  usePostV2ProviderWaitingRoomQueueByEntryIdAdmitAdditionalMutation,
} = injectedRtkApi;
